/**
 * Configuration Layer
 * 
 * Centralizes all configuration service singletons for easy access across the codebase
 */

// Import and export the singleton instances
const mainConfigService = require('.//MainConfigService');
const applePayConfigService = require('./ApplePayConfigService');
const googlePayConfigService = require('./GooglePayConfigService');
const samsungPayConfigService = require('./SamsungPayConfigService');
const walletConfigService = require('./WalletConfigService');

module.exports = {
  mainConfigService,
  applePayConfigService,
  googlePayConfigService,
  samsungPayConfigService,
  walletConfigService,
};